<template>
  <div class="home-view">
    <HeroSection></HeroSection>
    <FollowUsSection></FollowUsSection>
    <CoursesSection></CoursesSection>
    <SocialMediaSection></SocialMediaSection>
  </div>
</template>

<script>
import HeroSection from '@/components/HomePage/HeroSection.vue';
import FollowUsSection from '@/components/HomePage/FollowUsSection.vue';
import CoursesSection from '@/components/HomePage/CoursesSection.vue';
import SocialMediaSection from '@/components/HomePage/SocialMediaSection.vue';

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    FollowUsSection,
    CoursesSection,
    SocialMediaSection,
  }
};
</script>

<style scoped>
/* Styles specific to the home view */
</style>